<template>
  <div class="main-container">
    <!-- Author: Bhushan
      Date: 10/02/2021
      Description: Income Tax Proof components-->
   <!--  <breadcrumb :list="breadcrumbList" />  -->
  
    <div class="margintop-16" />
    <tl-header type="h1" class="employee-fullname">Income Tax Proof Submission Form: {{` ${employeeObj.first_name} ${employeeObj.last_name} `}}</tl-header>
    <div class=" lineheight"></div>
    
    <!-- Section 1 -->
    <div class="container-fluid" id="example">
        <div class="row">
            <div class="col-2 first">
                <div>
                    <div class="img-user">
                    <img src="@/assets/user.svg" class="oval" />
                    </div>
                              
                    <div class="month">
                        <div class="employee-fullname"> {{` ${employeeObj.first_name} ${employeeObj.last_name} `}} </div>
                        <div class="employee-code"> {{ `${employeeObj.code}`}} </div>
                        <div class="date">Aug 2021</div>
                    </div>
                </div>
            </div>
            <div class="col-10-new last">
                <div class="row">
                    <div class="col-6 left-box-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="total-taxable-income">Planned Investment:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong>₹ 1,22,000</strong>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Actual Investment:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong> ₹ 0 </strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 right-box-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="total-taxable-income">Salary and Perks:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong>₹ 10,00,000</strong>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Total Taxable Income:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong> ₹ 942,000 </strong>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Annual Tax:</div>
                            </div>
                            <div class="col-6 amount-right">
                               <strong> ₹ 100,900 </strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="view-proof-title" @click="showPopupdependentsPopup = !showPopupdependentsPopup"><span class="view-proof-title-pointer">View Dependents</span></div>
                    </div>
                    <div class="col-4 side-hr-lr">
                        <div class="view-proof-title"><span class="view-proof-title-pointer">View TDS Breakup</span></div>
                    </div>
                    <div class="col-4">
                        <div class="view-proof-title"><span class="view-proof-title-pointer">View IT Statement</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end section 1 -->

    <!-- Section 2 -->
    <div class="container-fluid">
      <div class="row my-4">
        <div class="col-9 pl-0">
            <div class="deduction-title">
              Final Step for submission
            </div>
            <div class="total-taxable-income my-3">
              Download following forms, send them to employee for self declaration.
              Reupload self declared forms to complete submission.
            </div>
            <div class="row my-3">
              <div class="col-3 pl-0">
                <div class="bg-color">
                  <a href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/TDPL+Form-12BB.pdf' target="_blank">
                  <strong>Form 12BB</strong> <img class="img-icon-download-form" src="@/assets/download.svg" alt />
                  </a>
                </div>
              </div>
              <div class="col-4">
                <div class="bg-color">
                  <a href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/Future+Payment+Declaration.pdf' target="_blank">
                  <strong>Future Payment Declaration</strong> 
                  <img class="img-icon-download-form" src="@/assets/download.svg" alt />
                  </a>
                </div>
              </div>
              <div class="col-5">
                <div class="bg-color">
                  <a href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/HRA+Future+Payment+Declaration.pdf' target="_blank">
                  <strong>HRA - Future Payment Declaration</strong> 
                  <img class="img-icon-download-form" src="@/assets/download.svg" alt />
                  </a>
                </div>
              </div>
            </div>
        </div>
        <div class="col-3 pr-0">
            <div class="add-new-investment" @click="editInvestmentPlan">
              <span class="add-new-investment-pointer">
              <img class="img-icon" src="@/assets/edit.svg" alt />
                Edit Investment Plan
              </span>
            </div>
        </div>
      </div>
    </div>
    <!-- end section 2 -->

    <!-- Section 3 -->
    <div class="container-fluid">
      <div class="row my-4">
        <div class="col-12 pl-0">
            <div class="deduction-title">
              Sign and Re-upload
            </div>
            <div class="row my-3">
              <div class="col-3 pl-0">
                <span class="">
                  Form 12BB
                </span>
                <div class="bulkUploadClass" v-if="uploadMethod =true">
                  <div class="margin-t-15px">
                    <upload name="form12bb" :tobucket="false" @change="onFileChange($event,'form12bb')"  :status="statusA"></upload>
                  </div>
                </div>
                <div class="delete-form margin-t-15px" v-else>
                  <div class="delete-sction-from"> 
                    <span class="file-upload-text">File Upoaded</span>  
                    <img class="img-icon-delete-form" src="@/assets/delete.svg" alt />
                  </div>
                </div>
              </div>
              <div class="col-3 ml-2">
                <span class="">
                  Future Payment Declaration
                </span>
                <div class="bulkUploadClass" v-if="uploadMethod =true">
                  <div class="margin-t-15px">
                    <upload name="future" :tobucket="false" @change="onFileChange($event,'future')" :status="statusB"></upload>
                  </div>
                </div>
              </div>
              <div class="col-3 ml-4">
                <span class="">
                  HRA - Future Payment Declaration
                </span>
                <div class="bulkUploadClass" v-if="uploadMethod =true">
                  <div class="margin-t-15px">
                    <upload name="future-hra" :tobucket="false" @change="onFileChange($event,'future-hra')" :status="statusC"></upload>
                  </div>
                </div>
              </div>
              <div class="col-3">
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- end section 3 -->
    
    <!-- Popup 1 -->
    <pop-up-window
        v-if="showPopupdependentsPopup"
        @back="showPopupdependentsPopup = !showPopupdependentsPopup"
        header="Dependents"
        >
          <template v-slot:content>
            <dependents-popup
            @back="showPopupdependentsPopup = !showPopupdependentsPopup"
            @openNewDependents = "openNewDependents" 
            >
            </dependents-popup>
         </template>
    </pop-up-window>
    <!-- End -->
    <!-- Popup 2 -->
    <pop-up-window
        v-if="showPopupaddDependentsPopup"
        @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
        header="Dependents"
        >
          <template v-slot:content>
            <add-dependents-popup
            @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
            @saveDependent = "saveDependent"
            >
            </add-dependents-popup>
         </template>
    </pop-up-window>
    <!-- End -->
            <pop-up-message v-if="showSuccessMsg" :closable="true" message="Files submitted successfully" popupHeaderMessage="Success." btnText="Ok" @back="backfrompopup()">
        <template v-slot:bottomContent>
  <div class="popup-btn-group">
    <button class="btn-popup" type="button" @click="backfrompopup()">Back</button>
  </div>
</template>
        </pop-up-message>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="backpreviouspage" />
          <btn text="Submit Forms" type="primary" @click="submitProofs"/>
        </btn-grp>
      </template>
    </bottom-action-container>
    
    
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { api_variables } from "@/apis/variables.js";
import dependentsPopup from "./dependentsPopup.vue";
import addDependentsPopup from "./addDependentsPopup.vue";
import { eventBus } from "@/main";

export default {
  components: {
    dependentsPopup,
    addDependentsPopup,
  },
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_BULK_UPLOAD,
      employeeObj: null,
      showConfirmationMsg: false,
      file:null,
      showSuccessMsg:false,
      
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: []
      },
      it_plan_id:"",
      employeeId:"",
      instance:{
        le_id:"",
        employee_id:"",
        financial_year:"2020",
        it_plan_id:"",
        files: new FormData(),
      },
      statusA:0,
      statusB:0,
      statusC:0,
      data2:{
      exemption10:[],
      exemption17:[],
      deductionsUnderSection16:[],
      deductionsUnderChapterVIA:[],
      section24:[],
      previousEmploymentDetails:{},
      othesection10updaterIncome:[],
      le_id:"",
      employee_id:"",
      financial_year:"",
      plan_id:"",
      regime_type:"",
      },
      
      salaryPerk:[],
      tds_breakup_and_taxable_income:[],
      itSheet:[],
      first_name:"",
      last_name: "",
      ctc:"",
      code:"",
      totalIncomeTax:"",
      annualTax:"",
      showPopupdependentsPopup: false,
      showPopupaddDependentsPopup: false,
      showPopupaddNewInvestmentPopup: false,

      tableColumnsSection10: [
                {
                label: "Particulars",
                key: "particulars"
                },
                {
                label: "Yearly Limit",
                key: "yearly_limit"
                },
                {
                label: "Planned Investment(₹)",
                key: "planned_investment"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual_investment"
                },
                {
                label: "Proofs",
                key: "proofs_attachment"
                },
      ],
      section10List: [
        {
          particulars: "HRA",
          yearly_limit: "2,00,000",
          planned_investment: "1,35,000",
          actual_investment: "",
          proofs_attachment: "-",
          actual: 0,
        },
      ],
      tableColumns80C: [
                {
                label: "Particulars",
                key: "particulars"
                },
                {
                label: "Yearly Limit",
                key: "yearly_limit"
                },
                {
                label: "Planned Investment(₹)",
                key: "planned_investment"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual_investment"
                },
                {
                label: "Proofs",
                key: "proofs_attachment"
                },
      ],
      data80CList: [
        {
          particulars: "LIC Premium",
          yearly_limit: "-",
          planned_investment: "2,35,000",
          actual_investment: "",
          proofs_attachment: "-",
          actual: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
         }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
    
  },

  mounted() {
    this.fetchRecord();
  },
  activated() {
    this.fetchRecord();
  },

  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_plan:"dashboard/payroll/incometax/setPlanName",
      act_get_plan:"dashboard/payroll/incometax/getPlan",
      act_active_plan:"dashboard/payroll/incometax/activatePlan",
       act_get_active_it_plan:"dashboard/payroll/incometax/getActiveList",
       uploaddocs: "dashboard/payroll/incometax/create"
    }),

   async fetchRecord() {
        
        let empId = this.$route.query.id;
        //console.log("Data EMP ID...",empId);

        this.instance.employee_id = empId;
        let res2 = await this.act_get_active_it_plan(empId);
        //console.log("activeplan data ",res2);
        this.it_plan_id=res2.data.payload.id;
        this.instance.it_plan_id=this.it_plan_id;
        this.instance.le_id= this.le_id;

        this.employeeObj = empId;
        //console.log("Data Formsss...",this.instance);
        let payload ={
          empId:empId,
          empLeId:this.le_id
        }
        let res = await this.act_fetchEmpById(payload);
        this.employeeObj = res.data.payload.data;
        this.empCtc=this.employeeObj.EmployeeSalarySetting[0].ctc
        
  },

  backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`
      });
  },
    
  saveplan() {
      this.showConfirmationMsg = true;
  },

  /* function to hide the confimation pop-up */
  cancelEvent() {
      this.showConfirmationMsg = false;
  },

  openNewDependents() {
    this.showPopupdependentsPopup = false;
    this.showPopupaddDependentsPopup = true;
  },

  saveDependent() {
    this.showPopupdependentsPopup = true;
    this.showPopupaddDependentsPopup = false;
  },

  editInvestmentPlan() {
    this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`,
      });
  },

  async submitProofs() {
           
     try {
       
       this.instance.files.append("le_id", this.instance.le_id);
       this.instance.files.append("employee_id", this.instance.employee_id);
       this.instance.files.append("it_plan_id", this.instance.it_plan_id);
       this.instance.files.append("financial_year", this.instance.financial_year);
       //console.log("checking instance before sending",this.instance.files);
        let res = await this.uploaddocs(this.instance.files);
        //console.log("res",res);
        if (res.status){
        //this.showSuccessMsg = true;
        eventBus.$emit("showsubmitproof", this.instance.employee_id);
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`,
    });}
      } catch (err) {
        //console.log(err);
      }
    
  },

  async onFileChange(event, form) {
      try {
       //console.log("chekc event", event);
       //console.log("check form data",form);
      if (form == "form12bb") {
          this.statusA = 2;
           this.instance.files.append("files", event);
        }
      if (form == "future") {
          this.statusB = 2;
           this.instance.files.append("files", event);
        }   
      if (form == "future-hra") {
          this.statusC = 2;
           this.instance.files.append("files", event);
        } 
       
      } catch (error) {
        //console.log(error);
        this.errmsg = error;
        this.toast = true;
      }
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.col-10-new {
    -ms-flex: 0 0 83.33334%;
    -webkit-box-flex: 0;
    flex: 0 0 83.33334%;
    max-width: 83.33334%;
}

.left-box-6 {
    padding: 25px;
    border-right-width: 0;
    border: 1px solid #c9c9c9;
    border-left-width: 0;
    border-top-width: 0;
}

.right-box-6 {
    padding: 25px;
    border: 1px solid #c9c9c9;
    border-right-width: 0;
    border-top-width: 0;
    border-left-width: 0;
}

.amount-right {
    text-align: right;
}

.side-hr-lr {
    border: 1px solid #c9c9c9;
    border-top-width: 0;
    border-bottom-width: 0;
    height: 55px;
}

.view-proof-title {
  text-align: center;
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.view-proof-title-pointer {
  cursor: pointer;
}

.add-new-investment {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.add-new-investment-pointer {
  cursor: pointer;
}

.img-icon {
  transform: translate(-1px, 5px);
}

.atch-img {
  margin-right: 10px;
  transform: rotate(45deg);
}

.attachment-text {
  transform: translate(0px, 2px);
  position: absolute;
  font-size: 12px;
}

.bg-color {
  background-color: #eeeeee;
  padding: 10px 0 13px;
  border-radius: 8px;
  text-align: center;
}

img.img-icon-download-form {
  width: 24px;
  transform: translate(15px, 3px);
}

.delete-form {
  width: 316px;
    height: 146px;
    border-radius: 12px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
    background-color: #f6ffff;
    padding: 12px 12px 12px 12px;
}

.delete-sction-from {
  margin-top: 14%;
  margin-left: 20px;
}

span.file-upload-text {
  font-weight: 600;
}

img.img-icon-delete-form {
  float: right;
  margin-right: 18px;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center{
  margin: 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}

.img-user {
    margin: auto 0;
    text-align: center;
}

.month {
    margin-top: 8px;
    text-align: center;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

// #example .col-4 {
//   border: 1px solid #c9c9c9;
// }

// #example .col-4:not(:last-child) {
//   border-right-width: 0;
// }

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
    height: 210px;
    padding: 32px;
    border-radius: 10px 0px 0px 10px;
    border: solid 1px #dddddd;
}    

.middle {
    //max-width:37%;
    height: 210px;
    padding: 32px;
    // border-radius: 10px 0px 0px 10px;
    // border: solid 1px #dddddd;
}

.last {
    // max-width: 37%;
    // flex: 0 0 37%;
    height: 210px;
    //padding: 32px;
    border-radius: 0px 10px 10px 0px;
    border: solid 1px #dddddd;
    border-left-width: 0;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color:#ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}



  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 20px;
      line-height: 25px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}
</style>
